//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import ImageUpload from './ImageUpload'

const paymentDefault = {
    paidbyid: 0,
    paid_amount: "",
    paid_date: "",
    paid_time: "",
    channel: "",
    remark: "",
    image_file: null,
}
const formErrorsDefault = {
    paid_amount: false,
    paid_datetime: false,
}
export default {
  name: "PayinCreate",
  components:{
      VueCtkDateTimePicker,
      ImageUpload
  },
  data() {
    return {
        formErrors: {...formErrorsDefault},
        loading: false,
        datePayment: '',
        payment: {...paymentDefault}
    };
  },
  props: [ 
    'handleCreatePayment',
  ],
  watch:{
      datePayment(newDatePayment) {
        if(newDatePayment){
            const newDatePaymentArray = newDatePayment.split(' ')
            this.payment.paid_date = newDatePaymentArray[0]
            this.payment.paid_time = newDatePaymentArray[1]
        }else{
            this.payment.paid_date = ''
            this.payment.paid_time = ''
        } 
        this.validate()
      }
  },
  mounted(){
      
  },
  beforeDestroy() {
  },
  methods: {
    validate(){
        this.formErrors.paid_amount = !this.payment.paid_amount ? true : false
        this.formErrors.paid_datetime = this.payment.paid_date == '' || this.payment.paid_time == '' ? true : false
        return this.formErrors.paid_amount === true || this.formErrors.paid_datetime === true
    },
    handleUploadImage(file) {
        this.payment.image_file = file
    },
    handleUpdateInput(e){
        this.validate()
    },
    async createPayment(){
        const hasError = this.validate()
        if(hasError === true){
            return
        }
        this.loading = true
        const resCreatePayment = await this.handleCreatePayment(this.payment)
        if( resCreatePayment && resCreatePayment.success == true ){
            this.payment = {...paymentDefault}
            this.datePayment = ''
            if( this.$refs.imageFile && this.$refs.imageFile.onRemoveFile ){
                this.$refs.imageFile.onRemoveFile()
            }
            setTimeout(()=>{
                this.formErrors = {...formErrorsDefault}
            },100)
        }
        this.loading = false
    }
  }
}
